import React from 'react'
import styled from 'styled-components'
import { Row } from 'antd'
import { useTranslation } from 'react-i18next'
import WorkList from '../../Component/JobList'
import Jumbotron from '../../Component/Jumbotron'

const AllWorks = () => {
    // eslint-disable-next-line
    const {t} = useTranslation()

    return (
        <>
            <Jumbotron height={40} message={'Experiencia'}/>
            <Container>
                <Row justify='center' align='middle' style={{width: '100%', padding: '30px 0', flexDirection: 'column'}}>
                    <WorkList displayed={999} col={13}/>
                </Row>
            </Container>
        </>
    )
}

export default AllWorks;

const Container = styled.div`
    background-color: #f0f2f5;
    & *{
        color: #010008;
        font-family: 'Share Tech Mono', monospace;
    }
    & h2 {
        font-size: 30px;
    }
`
